/* eslint-disable no-console */
import ReactGA from 'react-ga'
import {GAnalytics} from '../config'

let enabled = false

export const initialize = () => {
  if (GAnalytics != null) {
    try {
      ReactGA.initialize(GAnalytics)
      enabled = true
    }
    catch(e) {
      console.log(`ReactGA initialize exception ${e.message}`)
    }
  }
}

export const set = data => {
  if (enabled) {
    try {
      ReactGA.set(data)
    }
    catch(e) {
      console.log(`ReactGA set exception ${e.message}`)
    }
  }
}

export const pageview = page => {
  if (enabled) {
    try {
      ReactGA.pageview(page)
    }
    catch(e) {
      console.log(`ReactGA pageview exception ${e.message}`)
    }
  }
}

export const modalview = name => {
  if (enabled) {
    try {
      ReactGA.modalview(name)
    }
    catch(e) {
      console.log(`ReactGA modalview exception ${e.message}`)
    }
  }
}

export default {enabled, initialize, set, pageview, modalview}



// WEBPACK FOOTER //
// ./src/analytics/google.js